<template>
  <div>
    <header-bar></header-bar>
    <div
      class="videomask"
      v-if="videoState == true"
      @click="masksCloseFun"
    ></div>
    <div class="videomasks" v-if="videoState == true">
      <video
        src="https://static4.coolbrainscience.cn/71b8b3b512a74b028743929a7648f835.mp4"
        controls="controls"
        autoplay
        width="100%"
      >
        当前浏览器不支持 video直接播放。
      </video>
    </div>
    <div class="part_1">
      <swiper class="fade" :options="swiperOption">
        <!-- <swiper-slide class="banner1">
          <img
            src="https://static4.coolbrainscience.cn/9e271ef44c7343009c6e2b36c2cc9646.png"
            alt=""
            class="bg_homepage"
          />
          <div class="part_1_content">
            <div class="part_1_content1">
              <div class="part_1_content1_left">
                <div class="title">白天精力好 晚上睡得香</div>
                <div class="subtitle">&emsp;</div>
                <a href="http://e.tb.cn/h.gE20BU63L3Y36AZ?tk=B3LD3l8nVAx HU9196"
                  ><button type="button">购买</button></a
                >
              </div>
              <img
                src="https://static4.coolbrainscience.cn/f101706714554a0b8fb2dd14519a1950.png"
                class="headband"
              />
            </div>
            <div class="part_1_content2" id="user_pain_points">
          <div class="title1">你是否有这些困扰？</div>
          <div class="plague">
            <div class="plague_top">
              <div class="plague1">
                <img
                  src="https://static4.coolbrainscience.cn/dcb42e3bdc6040568275b7d50123c8ce.png"
                />
                <div class="t">
                  <div class="t1">白天精力不足</div>
                  <div class="t2">大脑精力浓度不足</div>
                </div>
              </div>
              <div class="plague2">
                <img
                  src="https://static4.coolbrainscience.cn/b3c6d9be82084b8db60566a035ad1588.png"
                />
                <div class="t">
                  <div class="t1">睡眠质量差</div>
                  <div class="t2">大脑休息深度不足</div>
                </div>
              </div>
            </div>
            <div class="plague_bottom">
              <div class="plague1">
                <img
                  src="https://static4.coolbrainscience.cn/36f5be9449b24f87b55419affecb9fa8.png"
                />
                <div class="t">
                  <div class="t1">工作学习效率低下</div>
                  <div class="t2">脑力低</div>
                </div>
              </div>
              <div class="plague2">
                <img
                  src="https://static4.coolbrainscience.cn/5a4ae92c516e4528be39545a3f5ba125.png"
                />
                <div class="t">
                  <div class="t1">睡醒后精神不振</div>
                  <div class="t2">大脑困倦感积累不足额叶兴奋难以入眠</div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
        </swiper-slide> -->
        <swiper-slide class="banner2">
          <img
            src="https://static4.coolbrainscience.cn/5edd3309da924929baf1ff2af0c4248b.png"
            alt=""
          />
          <div class="part_1_content2">
            <div class="t1">LOTUS 2</div>
            <div class="t2">般意精力舱 II 代</div>
            <div class="t3">白天静心 夜晚酣眠</div>
            <div class="t4">
              让般意精力舱帮你拥有稳定情绪和睡眠全面掌控自己的人生
            </div>
            <a href="http://e.tb.cn/h.gEW4kkPBhpwM0Kw?tk=wlAu3lQH1Ei CZ0000"
              ><button type="button">购买</button></a
            >
          </div>
        </swiper-slide>
        <swiper-slide class="banner3">
          <img
            src="https://static4.coolbrainscience.cn/9a641264ca6b43a4b38097c0704272be.png"
            alt=""
          />
          <div class="part_1_content3">
            <div class="t1">LOTUS 2R</div>
            <div class="t2">般意精力舱 II 代</div>
            <div class="t3">专注记忆 行动速达</div>
            <div class="t4">
              让般意精力舱帮你提升精力和能量在高强度工作中保持长久续航力
            </div>
            <a href="http://e.tb.cn/h.gvgdhm8Uw1XCPcU?tk=jcgJ3lQtNNG CZ3452"
              ><button type="button">购买</button></a
            >
          </div>
        </swiper-slide>
        <swiper-slide class="banner1">
          <img
            src="https://static4.coolbrainscience.cn/9e271ef44c7343009c6e2b36c2cc9646.png"
            alt=""
            class="bg_homepage"
          />
          <div class="part_1_content">
            <div class="part_1_content1">
              <div class="part_1_content1_left">
                <div class="title">白天精力好 晚上睡得香</div>
                <div class="subtitle">&emsp;</div>
                <a href="http://e.tb.cn/h.gE20BU63L3Y36AZ?tk=B3LD3l8nVAx HU9196"
                  ><button type="button">购买</button></a
                >
              </div>
              <img
                src="https://static4.coolbrainscience.cn/f101706714554a0b8fb2dd14519a1950.png"
                class="headband"
              />
            </div>
            <!-- <div class="part_1_content2" id="user_pain_points">
          <div class="title1">你是否有这些困扰？</div>
          <div class="plague">
            <div class="plague_top">
              <div class="plague1">
                <img
                  src="https://static4.coolbrainscience.cn/dcb42e3bdc6040568275b7d50123c8ce.png"
                />
                <div class="t">
                  <div class="t1">白天精力不足</div>
                  <div class="t2">大脑精力浓度不足</div>
                </div>
              </div>
              <div class="plague2">
                <img
                  src="https://static4.coolbrainscience.cn/b3c6d9be82084b8db60566a035ad1588.png"
                />
                <div class="t">
                  <div class="t1">睡眠质量差</div>
                  <div class="t2">大脑休息深度不足</div>
                </div>
              </div>
            </div>
            <div class="plague_bottom">
              <div class="plague1">
                <img
                  src="https://static4.coolbrainscience.cn/36f5be9449b24f87b55419affecb9fa8.png"
                />
                <div class="t">
                  <div class="t1">工作学习效率低下</div>
                  <div class="t2">脑力低</div>
                </div>
              </div>
              <div class="plague2">
                <img
                  src="https://static4.coolbrainscience.cn/5a4ae92c516e4528be39545a3f5ba125.png"
                />
                <div class="t">
                  <div class="t1">睡醒后精神不振</div>
                  <div class="t2">大脑困倦感积累不足额叶兴奋难以入眠</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
          </div>
        </swiper-slide>
      </swiper>
      <!-- <div class="part_1_content3">
        那是因为你的大脑“共振”失调，脑力进入恶性循环
      </div> -->
    </div>
    <div class="part_2">
      <img
        src="https://static4.coolbrainscience.cn/0189ed39a0314cb593535721e0a122f2.gif"
        alt="Loading GIF"
      />
      <div class="part_2_content">
        <p class="t1">般意精力舱是什么？</p>
        <p class="t2">你的高科技大脑助手</p>
        <p class="t3">
          般意精力舱是国内首创家用型经颅电刺激干预设备，基于非侵入式脑机接口技术，电干预全面深度作用于额叶皮层神经元，帮助恢复神经递质内在平衡，重启神经可塑性，长期使用帮助提升综合认知能力，流体智力，、和伴随的睡眠障碍。
        </p>
      </div>
    </div>
    <div class="part_3">
      <p class="t1">国内外多项技术认证</p>
      <img src="../../assets/renzheng_logo.png" alt="" />
      <div class="t3">
        <p>通过国家<br />CMA检验认证</p>
        <p>通过国际<br />实验室认证</p>
        <p>通过国家<br />实验室认证</p>
        <p>欧洲合格<br />认证</p>
        <p>通过国家<br />标准认证</p>
        <p>通过中国无线<br />电核准认证</p>
        <p>通过人体<br />电磁辐射检测</p>
        <p>美国FCC<br />质量认证</p>
      </div>
    </div>
    <div class="part_4">
      <img
        src="https://static4.coolbrainscience.cn/9c1861fbf87642aba77270eb01c59477.png"
        alt=""
      />
      <div class="part_4_content1">
        <p class="t1">源自耶鲁脑科学博士后团队的重磅产品</p>
        <p>国内首款基于经颅深度电刺激技术，活化大脑额叶神经元</p>
        <button @click="navigateToPage">了解更多</button>
      </div>
      <div class="part_4_content2">
        <p class="t2">FOUNDER</p>
        <p>品牌创始人</p>
        <p>姚乃琳</p>
      </div>
    </div>
    <div class="part_5">
      <div class="part_5_content1">
        <img src="../../assets/1@2x.png" alt="" />
        <p>专业售后团队<br />全方位定制化6v1</p>
      </div>
      <div class="line"></div>
      <div class="part_5_content2">
        <img src="../../assets/2@2x.png" alt="" />
        <p>安心购物 <br />7天无理由退换货1年保修</p>
      </div>
      <div class="line"></div>
      <div class="part_5_content3">
        <img src="../../assets/3@2x.png" alt="" />
        <p>
          顺丰包邮 <br />
          免费配送
        </p>
      </div>
      <div class="line"></div>
      <div class="part_5_content4">
        <img src="../../assets/4@2x.png" alt="" />
        <p>会员臻享 <br />入会享权益</p>
      </div>
    </div>
    <div class="part_6">
      <swiper class="part_6_content" :options="swiperOptionTop">
        <swiper-slide
          ><img
            src="https://static4.coolbrainscience.cn/e5e9b080b7114334a1f1436e6f67051f.gif"
            alt=""
            class="swiper-img"
        /></swiper-slide>
        <swiper-slide
          ><img
            src="https://static4.coolbrainscience.cn/34b30ac6695d4401b151ff5dfad245e8.gif"
            alt=""
            class="swiper-img"
        /></swiper-slide>
        <swiper-slide
          ><img
            src="https://static4.coolbrainscience.cn/a0092645bb4f421aad082b9e9e4c8a6d.gif"
            alt=""
            class="swiper-img"
        /></swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
      </swiper>
    </div>
    <!-- <div class="part_2" id="improvement_effect">
      <div class="t1">使用PanBrain精力舱</div>
      <div class="t1">每天仅需15分钟给大脑做个深度重启</div>
      <div class="t2">平均10次干预后就可以收获显著的</div>
      <div class="effect">
        <div class="effect1">
          <img src="../../assets/icon1.png" />
          <p class="t3">35%</p>
          <p class="t4">水平下降</p>
        </div>
        <div class="effect2">
          <img src="../../assets/icon2.png" />
          <p class="t3">36%</p>
          <p class="t4">压力水平下降</p>
        </div>
        <div class="effect3">
          <img src="../../assets/icon3.png" />
          <p class="t3">34%</p>
          <p class="t4">情绪水平上升</p>
        </div>
        <div class="effect4">
          <img src="../../assets/icon4.png" />
          <p class="t3">38%</p>
          <p class="t4">认知能力上升</p>
        </div>
      </div>
    </div> -->
    <!-- <div class="part_3" id="usage_scenario">
      <img src="../../assets/wave.png" />
      <div class="slogan">
        <div class="part_3_t1">随时随地，给大脑充电</div>
        <div class="part_3_t2">
          清晨使用，精力充沛一整天；下午使用，给脑力续航，高效冲刺夜间工作；
        </div>
        <div class="part_3_t2">周末/旅行时使用，唤醒身心平静愉悦的力量。</div>
      </div>
    </div> -->
    <!-- <div class="part_4">
      <img @click="checkVideoFun()" src="../../assets/play.png" />
    </div> -->
    <!-- <div class="part_5">
      <div class="part_5_left">
        <div class="part_5_left1">
          <img src="../../assets/scenes_icon_recommend.png" class="img7" />
          推荐场景
        </div>
        <div class="part_5_left2">
          清晨起床后出门前使用，利用短短的整理和洗漱时间完成一天的精力提升，还可以快速清醒，同时不影响发型，晚上归家后的休息会更加高效有质量
        </div>
      </div>
      <div class="part_5_right">
        <div class="part_5_right1">
          <img src="../../assets/scenes_icon_superman.png" class="img8" />
          超人模式
        </div>
        <div class="part_5_right2">
          如果想要压缩睡眠时间，可以在下午两点后使用，会使入睡时间延后，但是不影响第二天的起床时间，且第二天不会因睡眠时间缩短而精神不济
        </div>
      </div>
    </div> -->
    <!-- <div class="part_6">
      <div class="part_6_1">
        <div class="part_6_content" style="margin-left: 30%">
          <img src="../../assets/scenes_icon_office.png" class="img9" />
          <div class="part_6_title1">办公室上班</div>
          <div class="part_6_title2">精力充沛</div>
        </div>
      </div>
      <div class="part_6_2">
        <div class="part_6_content">
          <img src="../../assets/scenes_icon_study.png" class="img9" />
          <div class="part_6_title3">居家学习</div>
          <div class="part_6_title4">高效专注</div>
        </div>
      </div>
      <div class="part_6_3">
        <div class="part_6_content">
          <img src="../../assets/scenes_icon_businessTrip.png" class="img9" />
          <div class="part_6_title1">出差</div>
          <div class="part_6_title2">轻巧便携</div>
        </div>
      </div>
      <div class="part_6_4">
        <div class="part_6_content" style="margin-right: 30%">
          <img src="../../assets/scenes_icon_holiday.png" class="img9" />
          <div class="part_6_title3">周末或旅行</div>
          <div class="part_6_title4">充分休息</div>
        </div>
      </div>
    </div> -->
    <div class="part_7" id="application_program">
      <div class="part_7_content">
        <div class="part_7_left">
          <div><img src="../../assets/panbrain.png" class="img10" /></div>
          <div><img src="../../assets/logo_black.png" class="img11" /></div>
          <div class="part_7_title1">般意手机应用</div>
          <div class="part_7_title2">
            般意是一款用于辅助硬件智能设备工作的手机应用。您可以轻松的通过装有般意的手机实现对
            PanBrain 旗下智能设备的操作和控制。
          </div>
          <div class="part_7_title3">
            在您使用硬件设备的过程中，般意会实现全程跟踪、辅助和引导以帮助您高效的获得脑力放松体验。与此同时，般意会对您的脑力数据实时分析，生成科学的报告，让您随时随地精准地获悉自己的精神状态，用更饱满的活力面对生活。
          </div>
          <button type="button" class="downBtn" @click="show = true">
            立即下载
          </button>
          <div class="mask" v-if="show">
            <div class="maskContent">
              <div class="mask_t1">下载应用程序</div>
              <img
                class="maskImg"
                src="https://static4.coolbrainscience.cn/ff9341044a2e468884b5f19eb3d82156.png"
              />
              <!-- <img class="qrCode"
                src="https://static4.coolbrainscience.cn/fcbf1827c02949ac9af47fb6b586c337.png"> -->
              <img class="qrCode" src="../../assets/qr_down.png" />
              <img
                @click="show = false"
                class="closeImg"
                src="https://static4.coolbrainscience.cn/073fae2b808b43bd9a02227dcc3b299e.png"
              />
              <div class="mask_t2">扫一扫上面的二维码，下载般意App</div>
            </div>
          </div>
        </div>
        <div class="part_7_right">
          <img
            src="https://static4.coolbrainscience.cn/20e0581b3be6485c94d0c4f60d67b659.png"
            class="img12"
          />
          <div class="download">
            <img src="../../assets/App_badge_downloadApple.png" class="img13" />
            <img
              src="../../assets/App_badge_downloadAndroid.png"
              class="img14"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <header-bar :active="active"></header-bar> -->
    <!-- <div class="mask" v-if="show">
      <div class="maskContent">
        <img class="maskImg" :src="require('./../../assets/kefu.png')" />
        <img @click="show = false" class="closeImg" :src="require('./../../assets/close.png')" />
      </div>
    </div> -->
    <!-- <div class="mask" v-if="show1">
      <div class="maskContent">
        <img class="maskImg" :src="require('./../../assets/bg.png')" />
        <img class="qrImg" :src="require('./../../assets/QR.png')" />
        <img @click="show1 = false" class="closeImg" :src="require('./../../assets/close.png')" />
        <div class="title">购买咨询</div>
        <p>扫一扫上面的二维码，联系顾问进行咨询</p>
      </div>
    </div> -->
    <!-- <div class="swipe" @mouseover="stopAutoPlay" @mouseleave="setAutoPlay">
      <div class="top checked" :style="backImg">
        <div class="topTitle" style="margin-left: 8.6vw">正念冥想修习</div>
        <div class="topCon" style="width: 32.4vw; margin-left: 8.6vw">
          长期练习冥想，可以升级脑力，平复情绪，你会从此体验到深层次的改变。
        </div>
        <div class="topCon" style="width: 42.8vw; margin-left: 8.6vw">
          近20年来，包括哈佛、耶鲁在内的世界顶级科研机构大量研究发现，练习正念冥想可以显著情绪，增强抗压能力，促进睡眠，提升大脑认知力。而随着情绪变好和认知力提高，你的人际关系也会发生积极的改变。
        </div>
        <div class="button" style="margin-left: 8.6vw">
          <div class="b1" @click="show = true">预约</div>
          <div class="b2" @click="$router.push('/mood')">了解更多</div>
        </div>
      </div>
      <div class="top" :style="backImg1">
        <div class="top2Title">PanBrain LOTUS 1</div>
        <div class="top2Con">起床第一件事，给大脑充电</div>
        <div class="button" style="display: flex; justify-content: center">
          <div class="b1" @click="show1 = true" style="border: 1px solid #333333; color: #333333">
            购买
          </div>
          <div class="b1" @click="$router.push('/device')" style="background: #333333; border: 1px solid #333333">
            了解更多
          </div>
        </div>
        <img src="../../assets/headband.png" />
      </div>
      <div class="circle">
        <li v-for="(item, index) in divCount" :key="index" @mouseover="indexBtn(index)"
          :class="{ indexBGC: currentIndex == index }"></li>
      </div>
    </div> -->
    <!-- <div class="homep">
      <div class="contgreen">
        <img class="ctImg" :src="require('./../../assets/6.png')" />
        <div class="ctTitle"></div>
        <div class="ctContent">
          练习正念冥想可以缩小大脑中负责情绪的杏仁核的体积，减少你无缘无故焦躁不安的状况，给你带来平静和愉悦的心情，获得内在的平和。通过正念冥想，我们能够从根源上更好地释放情绪，获得一种纯粹的平静，而不是依赖外在事物来逃避面对
        </div>
      </div>
      <div class="contgrey">
        <img class="ctImg" :src="require('./../../assets/10.png')" />
        <div class="ctTitle"></div>
        <div class="ctContent">
          正念通过缓解患者相关的状态，实现的效果。在练习正念冥想时，我们的大脑还能够得到休息和放松，而不是处于长时间高度紧绷的状态。
        </div>
      </div>
      <div class="contgreen">
        <img class="ctImg" :src="require('./../../assets/2.png')" />
        <div class="ctTitle">睡眠</div>
        <div class="ctContent">
          长期练习冥想并不会减少疼痛本身，但可以让人通过主动忽略疼痛而缓解痛感。正念冥想缓解疼痛的效果被应用在非常多的极度疼痛疾病中，比如晚期癌症患者。
        </div>
      </div>

      <div class="contgrey">
        <img class="ctImg" :src="require('./../../assets/8.png')" />
        <div class="ctTitle">延缓疼痛</div>
        <div class="ctContent">
          练习正念冥想可以缩小大脑中负责情绪的杏仁核的体积，减少你无缘无故焦躁不安的状况，给你带来平静和愉悦的心情，获得内在的平和。通过正念冥想，我们能够从根源上更好地释放情绪，获得一种纯粹的平静，而不是依赖外在事物来逃避面对
        </div>
      </div>
      <div class="contgreen">
        <img class="ctImg" :src="require('./../../assets/9.png')" />
        <div class="ctTitle">提高认知力</div>
        <div class="ctContent">
          大部分人的认知力在30岁左右就开始逐渐衰退了。持续的冥想练习可以使大脑中负责记忆的海马体变大，负责专注力、决策力的大脑额叶变厚，带来提高认知力的效果。
        </div>
      </div>
      <div class="contgrey">
        <img class="ctImg" :src="require('./../../assets/3.png')" />
        <div class="ctTitle">提高免疫力</div>
        <div class="ctContent">
          练习正念冥想可以提高免疫力。研究发现，在一段时间的冥想练习之后，人体内和压力相关的一些生物标记物和会降低。比如C
          反应蛋白，白细胞介素
          6和可的松是有关的生物标志物，它们的大量存在意味着身体发炎了，而随着练习正念冥想，身体中这些炎性标记物都会减少。
        </div>
      </div>

      <div class="bigcontgreen">
        <img class="ctImg" :src="require('./../../assets/1.png')" />
        <div class="ctTitle">延缓衰老</div>
        <div class="ctContent">
          正念冥想可以延缓衰老。人体细胞的DNA的端粒长度和衰老有着直接的关联，端粒越短，一个人在生理上就越老，练习正念冥想可以帮助延长端粒。在一个研究中，布莱克本博士和她的合作者让志愿者去北科罗拉州的香巴拉山静修，结果发现，完成了为期
          3 个月的静修课程的志愿者的端粒酶水平比没有上课的人群高30%
          。美国哈佛医学院博士 Sara
          Lazar的研究则发现，冥想能改变大脑结构，让大脑皮层变厚。多数人的大脑皮质层随年龄增长而衰老萎缩，而50岁的冥想者却可能拥有像20几岁年轻人的皮质面积。
        </div>
      </div>
      <div style="width: 27.6vw" class="contgrey">
        <img class="ctImg" :src="require('./../../assets/4.png')" />
        <div class="ctTitle">增强抗压力</div>
        <div class="ctContent">
          密集的正念冥想练习可以迅速降低人体促炎性因子基因的表达，减少压力和导致的皮质醇分泌，使身体摆脱的伤害。在大脑生理层面上，正念冥想可以使得负责情绪调控、自省、同情的大脑皮质灰质密度明显变大，让你从更高维度上看到自己，指导自己应对压力。
        </div>
      </div>
    </div> -->
    <footer-info></footer-info>
  </div>
</template>
<script>
// import axios from "axios";
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
// import "@/components/common/home.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  data() {
    return {
      show: false,
      videoState: false,
      // show1: false,
      // currentIndex: 0, //当前图片
      // intervalID: "", //停止interval的唯一id
      // divCount: 0,
      // backImg: {
      //   background: "url(" + require("./../../assets/home.png") + ")",
      //   backgroundSize: "100% 100%",
      // },
      // backImg1: {
      //   background: "url(" + require("./../../assets/home2.png") + ")",
      //   backgroundSize: "100% 100%",
      //   textAlign: "center",
      // },
      // active: 1,
      swiperOptionTop: {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        slideToClickedSlide: true,
        pagination: ".swiper-pagination",
        loop: true,
        direction: "horizontal",
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
        },
      },
    };
  },
  components: {
    footerInfo,
    headerBar,
    swiper,
    swiperSlide,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  mounted() {
    // this.divCount = document.getElementsByClassName("top").length;
    // setTimeout(() => {
    //   this.startTime();
    // }, 10);
    // axios
    //   .get(
    //     "https://www.easy-mock.com/mock/5a67ef8cbdf9f5437bb4979a/Data/homedata"
    //   )
    //   .then(response => {
    //     this.major = response.data.major;
    //     this.ads = response.data.ads;
    //   })
    //   .catch(error => {
    //     alert("网络错误不能访问");
    //   });
  },
  methods: {
    toLocal() {
      // let Id = window.localStorage.getItem('toId')
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
    checkVideoFun() {
      this.videoState = true;
    },
    masksCloseFun() {
      this.videoState = false;
    },
    navigateToPage() {
      this.$router.push("/home");
    },
    // stopAutoPlay() {
    //   this.stopTime();
    // },
    // stopTime() {
    //   window.clearInterval(this.intervalID);
    // },
    // setAutoPlay() {
    //   this.startTime();
    // },
    // startTime() {
    //   this.intervalID = window.setInterval(() => {
    //     this.currentIndex++;
    //     if (this.currentIndex > 1) {
    //       this.currentIndex = 0;
    //     }
    //     this.active = this.currentIndex + 1;
    //     this.selectImg(this.currentIndex);
    //   }, 8000);
    // },
    // indexBtn(index) {
    //   this.currentIndex = index;
    //   this.active = this.currentIndex + 1;
    //   this.selectImg(index);
    // },
    // selectImg(index) {
    //   let carousel = document.getElementsByClassName("top");
    //   this.clearClass(carousel);
    //   carousel[index].className = "top checked";
    // },
    // clearClass(arr) {
    //   for (let i = 0; i < arr.length; i++) {
    //     arr[i].className = "top";
    //   }
    // },
  },
  // destroyed() {
  //   window.sessionStorage.setItem('toId', '')
  // },
};
</script>
<!-- <style src="@/components/common/home.css" scoped></style> -->
<style scoped>
.videomask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: #000;
  opacity: 0.6;
}

.videomasks {
  width: 80%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* transform: translateX(-50%); */
  /* top: 30%; */
  z-index: 9999;
}

.mask {
  z-index: 1000;
  transition: opacity 0.3s;
  position: absolute;
  top: 0;
}

.maskContent {
  position: relative;
}

.mask_t1 {
  color: #ffffff;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  position: absolute;
  top: 3vw;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.maskImg {
  width: 27.9vw;
  height: 32.5vw;
  position: relative;
}

.qrCode {
  width: 14.58vw;
  height: 14.58vw;
  position: absolute;
  top: 8.3vw;
  left: 6.5vw;
}

.closeImg {
  width: 1.67vw;
  height: 1.67vw;
  position: absolute;
  top: 0.3vw;
  right: 0.3vw;
}

.mask_t2 {
  color: #333333;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  position: absolute;
  bottom: 4.7vw;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.part_1 {
  width: 100vw;
  height: 56.162vw;
  overflow: hidden;
}

.bg_homepage,
.banner2 img,
.banner3 img {
  width: 100vw;
  height: 56.162vw;
}

.part_1_content {
  width: 100vw;
  position: absolute;
  top: 16vw;
}

.part_1_content2,
.part_1_content3 {
  position: absolute;
  top: 14.22vw;
  width: 29.17vw;
  left: 13.07vw;
}

.part_1_content2 .t1,
.part_1_content3 .t1 {
  font-size: 1.67vw;
  background: linear-gradient(90deg, #3c290e 0%, #a2795b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_1_content3 .t1 {
  background: linear-gradient(90deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.part_1_content2 .t2,
.part_1_content3 .t2 {
  font-size: 2.71vw;
  background: linear-gradient(90deg, #3c290e 0%, #a2795b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_1_content3 .t2 {
  background: linear-gradient(90deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.part_1_content2 .t3,
.part_1_content3 .t3 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  background: linear-gradient(0deg, #a87e5f 0%, #333333 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
}

.part_1_content3 .t3 {
  background: linear-gradient(359.9935267643712deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.part_1_content2 .t4,
.part_1_content3 .t4 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.part_1_content2 button,
.part_1_content3 button {
  background: #b58864;
  border-radius: 0.3vw;
  border: none;
  width: 10.16vw;
  height: 3.125vw;
  color: #ffffff;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  margin-top: 2.5vw;
}

.part_1_content3 button {
  background: #6b7cb5;
}

.part_1_content1_left {
  margin-left: 13.3vw;
}

.part_1_content1_left .title {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #333333;
  font-size: 3.1vw;
}

.part_1_content1_left .subtitle {
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  color: #9b9b9b;
  font-size: 1.7vw;
  margin-top: 1.7vw;
}

.part_1_content1_left button {
  width: 10.1vw;
  height: 3.1vw;
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  background: #888ef9;
  border-radius: 0.3vw;
  border: none;
  margin-top: 2.5vw;
  font-size: 0.9vw;
}

.headband {
  width: 47vw;
  height: 33vw;
  position: absolute;
  top: 0.4vw;
  left: 39.7vw;
}

.part_2 {
  width: 100vw;
  height: 28.125vw;
  background: #02080a;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}

.part_2 img {
  width: 50vw;
  height: 100%;
}

.part_2_content {
  width: 20vw;
}

.part_2_content .t1 {
  font-size: 2.19vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}

.part_2_content .t2 {
  font-size: 1.67vw;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
}

.part_2_content .t3 {
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_3 {
  width: 100%;
  background: #fafbfb;
  text-align: center;
  padding: 2.5vw 0;
  font-size: 1.67vw;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
  color: #333333;
}

.part_3 img {
  width: 73.4375vw;
  height: 4.1667vw;
}

.part_3 .t3 {
  display: flex;
  justify-content: center;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
}

.part_3 .t3 p {
  width: 9.1797vw;
}

.part_4 {
  padding-top: 2.5vw;
  width: 100%;
  text-align: center;
  position: relative;
}

.part_4 img {
  width: 73.4375vw;
  height: 31.25vw;
  border-radius: 2vw;
}

.part_4_content1 {
  position: absolute;
  top: 10.73vw;
  right: 20vw;
  text-align: left;
  font-size: 0.94vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
}

.part_4_content1 .t1 {
  background: linear-gradient(90deg, #0f203a 0%, #454a7d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.67vw;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
}

.part_4_content1 button {
  color: #ffffff;
  background: #1b1e8a;
  width: 10.156vw;
  height: 3.125vw;
  border-radius: 0.3125vw;
  border: none;
  font-size: 0.94vw;
}

.part_4_content2 {
  display: flex;
  position: absolute;
  left: 19.79vw;
  top: 23.125vw;
  font-size: 0.9375vw;
  text-align: left;
  font-family: "SourceHanSansCN-Medium";
  font-weight: 500;
  color: #333333;
}

.part_4_content2 p {
  writing-mode: vertical-rl;
  margin: 0;
}

.part_4_content2 .t2 {
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  color: #1b1e8a;
}

.part_5 {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding: 4.17vw 13.28vw;
  color: #333333;
  font-size: 0.94vw;
  text-align: center;
}

.part_5_content1,
.part_5_content2,
.part_5_content3,
.part_5_content4 {
  width: 11.67vw;
}

.part_5_content1 img {
  width: 3.88vw;
  height: 3.5vw;
}

.part_5_content2 img {
  width: 3.48vw;
  height: 3.06vw;
}

.part_5_content3 img {
  width: 3.08vw;
  height: 2.68vw;
}

.part_5_content4 img {
  width: 3.57vw;
  height: 3.07vw;
}

.line {
  border-left: 0.05vw solid #9b9b9b;
  height: 4.06vw;
  margin: 0 4vw;
}
/*.part_1_content2 {
  margin-top: 31.9vw;
  text-align: center;
}

.part_1_content2 .title1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #ffffff;
  font-size: 2.5vw;
}

.plague {
  font-size: 0;
}

.plague img {
  width: 27.3vw;
  height: 27.3vw;
}

.plague .t {
  position: absolute;
  bottom: 1vw;
  left: 50%;
  transform: translateX(-50%);
}

.plague1,
.plague2 {
  display: inline-block;
  width: 27.3vw;
  height: 27.3vw;
  position: relative;
  margin: 1.5vw 1vw 0.6vw 1vw;
}

.plague .t1 {
  font-size: 1.7vw;
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.plague .t2 {
  font-size: 0.9vw;
  color: #ffffff;
  white-space: nowrap;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_1_content3 {
  font-size: 1.7vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  color: #888ef9;
  text-align: center;
  padding: 6.3vw 0 2.7vw 0;
}

.part_2 {
  width: 100vw;
  padding: 4vw 0 6vw 0;
  background: #f3f4fe;
  text-align: center;
  position: relative;
}

.part_2 .t1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.2vw;
  color: #333333;
}

.part_2 .t2 {
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.6vw;
  color: #333333;
  margin: 1.25vw 0;
}

.effect div {
  width: 17.2vw;
  height: 10.4vw;
  background: #e0e0ff;
  display: inline-block;
  margin: 0 0.8vw;
  text-align: center;
}

.effect img {
  width: 4.17vw;
  height: 4.22vw;
  margin-top: 0.6vw;
  margin-bottom: 0.5vw;
}

.effect .t3 {
  color: #333333;
  font-size: 1.7vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin: 0;
}

.effect .t4 {
  color: #333333;
  font-size: 0.9vw;
  margin: 0;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_3 {
  width: 100vw;
  height: 20.8vw;
  background: #1b1e8a;
  text-align: center;
  position: relative;
}

.part_3 img {
  width: 73.5vw;
  height: 18.3vw;
  margin-top: 2vw;
}

.slogan {
  text-align: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 13.3vw;
}

.part_3_t1 {
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  color: #ffffff;
  font-size: 2.5vw;
  margin-bottom: 1.7vw;
}

.part_3_t2 {
  color: #ffffff;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_4 {
  width: 100vw;
  height: 56.25vw;
  /* background: url(https://static4.coolbrainscience.cn/38ca2aa5393a44d0abb4e9ada4bcc294.png)
    no-repeat; */
/*background: url(../../assets/1.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 56.25vw;
}

.part_4 img {
  width: 5.2vw;
  height: 5.2vw;
  vertical-align: middle;
}

.part_5 {
  background-color: #f3f4fe;
  width: 100vw;
  overflow: hidden;
}

.part_5_left,
.part_5_right {
  float: left;
  width: 40%;
  padding: 4.9vw 0 3.5vw 0;
  text-align: center;
}

.part_5_left {
  margin-left: 10%;
}

.part_5_left1,
.part_5_right1 {
  width: 10.9vw;
  color: #333333;
  font-size: 1.7vw;
  display: inline-block;
  vertical-align: top;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
}

.img7,
.img8 {
  width: 10.9vw;
  height: 10.7vw;
}

.part_5_left2,
.part_5_right2 {
  width: 50%;
  color: #333333;
  font-size: 0.9vw;
  margin-left: 2vw;
  text-align: justify;
  display: inline-block;
  margin-top: 1.6vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_6 {
  margin-top: 1.25vw;
  width: 100vw;
  text-align: center;
  font-size: 0;
}

.part_6_1 {
  width: 30%;
  background-color: #888ef9;
  position: relative;
  display: inline-block;
}

.part_6_content {
  padding: 3.1vw 0 3.3vw 0;
}

.part_6_2 {
  width: 20%;
  background-color: #f3f4fe;
  display: inline-block;
}

.part_6_3 {
  width: 20%;
  background-color: #888ef9;
  display: inline-block;
}

.part_6_4 {
  width: 30%;
  background-color: #f3f4fe;
  display: inline-block;
}

.img9 {
  width: 7.8vw;
  height: 7.8vw;
}

.part_6_title1 {
  font-size: 1.7vw;
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin-top: 1.9vw;
}

.part_6_title2 {
  color: #ffffff;
  font-size: 0.9vw;
  margin-top: 0.8vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_6_title3 {
  font-size: 1.7vw;
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  margin-top: 1.9vw;
}

.part_6_title4 {
  color: #333333;
  font-size: 0.9vw;
  margin-top: 0.8vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}**/

.part_7 {
  width: 100vw;
}

.img10 {
  width: 8.3vw;
  height: 8.3vw;
}

.part_7_content {
  padding: 4.4vw 0 3.75vw 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.part_7_left {
  width: 24%;
  position: relative;
}

.img11 {
  width: 15vw;
  height: 2.65vw;
  margin-top: 1.2vw;
}

.part_7_title1 {
  font-size: 3vw;
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin-top: 2.9vw;
}

.part_7_title2,
.part_7_title3 {
  color: #333333;
  font-size: 0.9vw;
  text-align: justify;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
}

.part_7_title2 {
  margin-top: 1.56vw;
}

.downBtn {
  background: #888ef9;
  width: 10.2vw;
  height: 3.1vw;
  border-radius: 0.3vw;
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
  border: 0;
  margin-top: 2.8vw;
}

.part_7_right {
  text-align: right;
  /* width: 55%; */
  margin-left: 7.5vw;
}

.img12 {
  width: 41.1vw;
  height: 39.3vw;
}

.download {
  margin-top: 2.1vw;
}

.img13 {
  width: 11.1vw;
  height: 4.1vw;
}

.img14 {
  width: 14.3vw;
  height: 4.1vw;
  margin-left: 2.4vw;
}
</style>
<style lang="less" scoped>
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 50vw;
  height: 100%;
}

.swiper-img {
  width: 50vw;
  height: 28.125vw;
}
</style>
<!--<style scoped>
  @font-face {
    font-family: 'fontmedium';
    src: url('../../font/SourceHanSansSC-Bold.otf')format('opentype');
  }

  @font-face {
    font-family: 'fontregular';
    src: url('../../font/SourceHanSansSC-Regular.otf')format('opentype');
  }

  @font-face {
    font-family: 'fontnormal';
    src: url('../../font/SourceHanSansSC-Normal.otf')format('opentype');
  }

  @font-face {
    font-family: 'fontbold';
    src: url('../../font/SourceHanSansSC-Bold.otf')format('opentype');
  }

  .swipe {
    width: 100vw;
    height: calc(14.6vw * 2 + 35vw);
    position: relative;
    /* overflow: hidden; */
  }

  .top {
    padding: 14.6vw 0;
    width: 100vw;
    height: 32vw;
    position: absolute;
  }

  .checked {
    z-index: 10;
  }

  li {
    list-style: none;
  }

  .circle {
    display: flex;
    position: absolute;
    bottom: 3vw;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }

  .circle li {
    width: 1vw;
    height: 1vw;
    margin: 1.2vw;
    border-radius: 50%;
    background-color: #b9b9b9;
    z-index: 100;
  }

  .circle .indexBGC {
    background-color: #4a4a4a;
  }

  .topTitle,
  .top2Title {
    font-size: 4.1vw;
    font-family: 'fontmedium';
    font-weight: 500;
    color: #ffffff;
    line-height: 3.5vw;
    margin-bottom: 1.4vw;
  }

  .top2Title {
    color: #000000;
    font-family: 'fontbold';
    margin-top: -3vw;
  }

  .topCon {
    font-size: 1.3vw;
    font-family: 'fontnormal';
    font-weight: 400;
    color: #ffffff;
    line-height: 2.5vw;
    margin-bottom: 2.1vw;
  }

  .top2Con {
    font-size: 2.8vw;
    font-family: 'fontmedium';
    color: #000000;
    margin-bottom: 2.1vw;
  }

  .top img {
    width: 38.8vw;
    height: 27.2vw;
    margin-top: 2.1vw;
  }

  .button {
    margin-top: 0.2vw;
    display: flex;
    font-size: 1.2vw;
    color: #fff;
  }

  .b1 {
    width: 8.1vw;
    height: 2.7vw;

    border-radius: 2.2vw;
    border: 1px solid #ffffff;
    text-align: center;
    line-height: 2.7vw;
    margin-right: 1vw;
    cursor: pointer;
  }

  .b2 {
    width: 8.1vw;
    height: 2.7vw;
    background: #233923;
    border-radius: 2.2vw;
    border: 1px solid #ffffff;
    text-align: center;
    line-height: 2.7vw;
    cursor: pointer;
  }

  .homep {
    /* height:63vw; */
    /* margin-top: -5.9vw; */
    margin-top: 22px;
    z-index: 100;
    display: flex;
    flex-wrap: wrap;
    padding-left: 8.5vw;
  }

  .contgreen {
    color: #233923;
    width: 23.6vw;
    height: 23.6vw;
    background: rgba(144, 167, 153, 0.24);

    border-radius: 9px;
    /* opacity: 0.24; */
    margin-right: 6vw;
    margin-bottom: 5vw;
    text-align: center;
  }

  .contgrey {
    width: 23.6vw;
    height: 23.6vw;
    border-radius: 9px;
    background: rgba(155, 155, 155, 0.24);
    /* opacity: 0.24; */
    margin-right: 6vw;
    margin-bottom: 5vw;
    text-align: center;
  }

  .bigcontgreen {
    color: #233923;
    width: 49.5vw;
    height: 23.6vw;
    background: rgba(144, 167, 153, 0.24);
    border-radius: 9px;
    filter: Alpha(opacity=24);
    /* opacity: 0.24; */
    margin-right: 6vw;
    margin-bottom: 5vw;
    text-align: center;
  }

  .ctImg {
    width: 3.1vw;
    height: 3.1vw;
    margin: 0 auto;
    margin-top: 2.1vw;
    margin-bottom: 0.7vw;
  }

  .ctTitle {
    font-size: 1.6vw;
    font-family: LucidaGrande;

    margin-bottom: 1.3vw;
  }

  .ctContent {
    font-size: 1.2vw;
    font-family: 'fontnormal';
    font-weight: 400;
    text-align: left;
    margin: 0 2vw;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    text-align: center;
    transition: opacity 0.3s;
  }

  .maskContent {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
    text-align: left;
    margin-top: 10vw;
    box-sizing: border-box;
    position: relative;
  }

  .maskContent p {
    position: relative;
    top: -5vw;
    text-align: center;
    color: #000000;
    font-size: 0.9vw;
    font-family: 'fontregular';
  }

  .maskImg {
    position: relative;
    width: 27.9vw;
    height: 32.4vw;
    border-radius: 1.2vw;
    box-shadow: 0 0.1vw 1vw 0 rgb(0 0 0 / 10%);
  }

  .closeImg {
    position: absolute;
    right: 1.1vw;
    top: 1.1vw;
    width: 1.1vw;
    height: 1.1vw;
  }

  .qrImg {
    position: absolute;
    width: 23vw;
    height: 23vw;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  }

  .title {
    font-size: 1.8vw;
    color: #FFFFFF;
    font-family: 'fontbold';
    margin-left: 2.2vw;
    position: absolute;
    /* left: 2.2vw; */
    /* top: -30vw; */
    top: 2.8vw;
  }
</style>-->



// WEBPACK FOOTER //
// src/components/pages/Device.vue